import * as React from 'react';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { type NavLinkProps } from 'react-router-dom';
import * as Styled from './styled';

export interface TabLinkProps extends Omit<NavLinkProps, 'children'> {
  active?: boolean;
  disabled?: boolean;
  closeable?: boolean;
  children: React.ReactNode;
  onClose?: React.MouseEventHandler<HTMLElement>;
}

const TabLink = (props: TabLinkProps) => {
  const { active, disabled, closeable, children, onClose, ...rest } = props;

  return (
    <Styled.Link
      {...rest}
      title={typeof children === 'string' ? children : undefined}
      $active={active}
      $disabled={disabled}
      $fixed={!closeable || active}
    >
      <span>{children}</span>
      {closeable && (
        <Button
          size="small"
          color="default"
          variant={active ? 'filled' : 'text'}
          ghost={active}
          icon={<CloseOutlined />}
          onClick={onClose}
        />
      )}
    </Styled.Link>
  );
};

export default TabLink;
